<template>
  <SideBarLayoutContent>
    <template #top-bar>
      <h1 class="text-headline-large">{{ $t('survey.title') }}</h1>
    </template>
    <BaseTabGroup :tab-items="tabItems">
      <BaseTabBar :tab-items="tabItems" class="mb-4 border-b" />
      <TabPanels>
        <TabPanel>
          <RunningSurveys />
        </TabPanel>
        <TabPanel>
          <FinishedSurveys />
        </TabPanel>
      </TabPanels>
    </BaseTabGroup>
  </SideBarLayoutContent>
</template>

<script setup lang="ts">
  import SideBarLayoutContent from '@/core/components/layouts/SideBarLayoutContent.vue'
  import { TabPanel, TabPanels } from '@headlessui/vue'
  import BaseTabBar from '@/core/components/base/tab-bar/BaseTabBar.vue'
  import BaseTabGroup from '@/core/components/base/tab-bar/BaseTabGroup.vue'
  import FinishedSurveys from '../components/FinishedSurveys.vue'
  import RunningSurveys from '../components/RunningSurveys.vue'

  const tabItems = [
    {
      id: 'running-surveys',
      title: 'Laufende Umfragen',
    },
    {
      id: 'finished-surveys',
      title: 'Abgeschlossene Umfragen',
    },
  ]
</script>
